(function button($, Drupal, dataLayer) {
  Drupal.behaviors.rutherfordButton = {
    attach(context) {
      $('[data-track-click]', context).click(function trackButtonClick() {
        dataLayer.push({
          eventCategory: $(this).data('trackClickCategory'),
          eventAction: $(this).data('trackClickAction'),
          eventLabel: $(this).data('trackClickLabel'),
        });
      });
    },
  };
})(jQuery, Drupal, window.dataLayer);
